import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';
import { Category } from '../../types';
import './CategoryNav.css';

interface CategoryNavProps {
  selectedCategoryId?: number;
}

const CategoryNav: React.FC<CategoryNavProps> = ({
  selectedCategoryId = 0
}) => {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const response = await apiService.getCategories();
      if (response.code === 0) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error('Failed to load categories:', error);
    }
  };

  return (
    <div className="category-nav">
      <div className="category-nav-container">
        <div className="category-nav-content">
          {/* All - 默认选中 */}
          <a
            href="/"
            className={`nav-item ${selectedCategoryId === 0 ? 'nav-item-active' : ''}`}
          >
            <span className="nav-text">All</span>
          </a>

          {/* 所有分类 */}
          {categories.map((category) => (
            <a
              key={category.id}
              href={`/category/${category.id}`}
              className={`nav-item ${selectedCategoryId === category.id ? 'nav-item-active' : ''}`}
            >
              <span className="nav-text">{category.name}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryNav;
